<template>
  <div
    class="flex flex-col bg-EXPONDO-white w-full h-full top-0 transition-[left]
      fixed z-50 overflow-y-auto px-6 py-10
      lg:static lg:z-auto lg:overflow-y-visible lg:p-0"
    :class="isFilterModalOpen ? 'left-0' : '-left-full'"
  >
    <ModalHeading
      :title="$t('Filter')"
      class="border-b-2 border-EXPONDO-grey-20 lg:hidden"
      @click-close-icon="toggleFilterModal"
    />

    <div class="flex-grow overflow-y-auto my-10 lg:my-0 lg:overflow-y-visible">
      <slot />
    </div>

    <button
      class="btn bg-EXPONDO-gold text-EXPONDO-primary py-3 w-full font-medium rounded lg:hidden"
      @click="toggleFilterModal"
    >
      <span>{{ $t('View n products', { count: productCount }) }}</span>
    </button>
    <div class="pt-4 text-center lg:hidden">
      <CtClearRefinements @clear="$emit('clear-all')" />
    </div>
  </div>
</template>

<script setup lang="ts">
// CT version of FilterModal; filters come through the slot.
defineOptions({ name: 'CtFilterModal' });

withDefaults(defineProps<{
  productCount?: number;
}>(), {
  productCount: 0,
});

defineEmits<{
  (event: 'clear-all'): void;
}>();

const { isFilterModalOpen, toggleFilterModal } = useUiState();
const { isMobile } = useUiMode();

const disableGlobalScroll = computed(() => isFilterModalOpen.value && isMobile.value);

watch(disableGlobalScroll, (value) => {

  if (value) {

    document.body.classList.add('overflow-y-hidden');

  } else {

    document.body.classList.remove('overflow-y-hidden');

  }

});
</script>

<style lang="scss" scoped>
:deep(.heading__close-button) {
  font-size: var(--h2-font-size);
  font-weight: var(--h2-font-weight);
  line-height: var(--h2-line-height);
}
</style>
